import * as $ from 'jquery';
import {random} from 'lodash';
import * as ko from 'knockout';
import {Observable} from "~knockout/index";
import {bootstrapGame, resetGame, startGame} from "./GameCore";

var gameManager: GameManager;

class GameManager
{
    paused: Observable<boolean>;
    score: Observable<number>;
    gameOverMessage: Observable<string>;
    timeRemaining: Observable<number>;
    currentLevel: Observable<number>;
    progress: Observable<string>;

    visibleBonus: Observable<string>;
    timeDelay: number;
    scoreDelay: number;

    game: Phaser.Game;
    
    constructor()
    {
        this.createBindings();
    }


    /**
     * create observable properties to let app elements communicate
     */
    createBindings()
    {
        this.paused = ko.observable(false);
        this.score = ko.observable(0);
        this.gameOverMessage = ko.observable(null);
        this.progress = ko.observable('0');
        this.currentLevel = ko.observable(0);
        this.timeRemaining = ko.observable(30);

        //  bonus observables

        this.visibleBonus = ko.observable();
        //this.showTimeBonus = ko.observable(true);
        //this.showvisibleBonus = ko.observable(true);

        // Here's a custom Knockout binding that makes elements shown/hidden via jQuery's fadeIn()/fadeOut() methods
// Could be stored in a separate utility library


        ko.bindingHandlers['visibleBonus'] =
        {
            init: (element: HTMLElement, valueAccessor: any) =>
            {
                //  hide the element

                //element.style.opacity = '0';

                //  initialise text binding

                ko.bindingHandlers.text.init();
            },
            update: (element: HTMLElement, valueAccessor: any) =>
            {
                // Whenever the value subsequently changes, slowly fade the element in or out

                var value: boolean = valueAccessor();

                //  if a displayable value has been passed in, display it and show the item

                if (ko.unwrap(value))
                {
                    ko.bindingHandlers.text.update(element, valueAccessor);

                    //  fade in the element

                    //$(element).fadeIn();

                    TweenMax.fromTo(element, 0.4, { scale: 0.1, opacity: 0, rotation: random(-5, 5, false), x: '-50%' }, { scale: 1, opacity: 1, rotation: 0, x: '-50%', ease: Back.easeOut });

                    //  clear any existing delays

                    if (this.scoreDelay) clearTimeout(this.scoreDelay);

                    //  and restart the delay so we can hide the readout after a short pause

                    this.scoreDelay = setTimeout(() =>
                    {
                        this.visibleBonus('');
                    }, 500);

                    return;
                }

                //  if an empty string has been passed, let's hide the item

                TweenMax.fromTo(element, 0.4, { scale: 1, opacity: 1 }, { scale: 0.1, opacity: 0, ease: Expo.easeOut });
            }
        };

        //ko.bindingHandlers['visibleBonus'] =
        //{
        //    init: (element: HTMLElement, valueAccessor: any) =>
        //    {
        //        //  hide the element
        //
        //        //element.style.opacity = '0';
        //
        //        //  initialise text binding
        //
        //        ko.bindingHandlers.text.init();
        //    },
        //    update: (element, valueAccessor) =>
        //    {
        //        // Whenever the value subsequently changes, slowly fade the element in or out
        //
        //        var value = valueAccessor();
        //
        //        //  if a displayable value has been passed in, display it and show the item
        //
        //        if (ko.unwrap(value))
        //        {
        //            ko.bindingHandlers.text.update(element, valueAccessor);
        //
        //            //  fade in the element
        //
        //            $(element).fadeIn();
        //
        //            //  clear any existing delays
        //
        //            if (this.timeDelay) clearTimeout(this.timeDelay);
        //
        //            //  and restart the delay so we can hide the readout after a short pause
        //
        //            this.timeDelay = setTimeout(() =>
        //            {
        //                this.visibleBonus('');
        //            }, 500);
        //
        //            return;
        //        }
        //
        //        //  if an empty string has been passed, let's hide the item
        //
        //        $(element).fadeOut();
        //    }
        //};
    }


    /**
     * bootstrap the phaser instance
     */
    createGame()
    {
        this.game = bootstrapGame();
    }


    /**
     * start playing the game
     */
    playGame()
    {
        //  reset and start the game

        this.resetGame();
    }


    /**
     * pause the game
     */
    pauseGame()
    {
        if ( ! this.game) return;

        this.game.paused = true;
    }


    /**
     * resume the game
     */
    resumeGame()
    {
        if ( ! this.game) return;

        this.game.paused = false;
    }
    

    /**
     * reset the game to its starting state
     */
    resetGame()
    {
        //  reset score and per-game properties
        
        this.score(0);
        this.gameOverMessage(null);
        
        //  reset the actual game content
        
        resetGame();

        //  start playing the game

        startGame();
    }


    /**
     * increase the player's current score by N
     * @param increment
     */
    incrementScore(increment: number)
    {
        this.score(Math.max(this.score() + increment, 0));
    }


    /**
     * increase the player's current time remaining by N
     * @param increment
     */
    incrementTimeRemaining(increment: number) : number
    {
        //  increment the value

        this.timeRemaining(this.timeRemaining() + increment);

        //  return the new amount of time remaining

        return this.timeRemaining();
    }

    /**
     * set the current game level
     */
    setCurrentLevel(level: number)
    {
        this.currentLevel(level + 1);
    }

    /**
     * set the amount of time remaining
     */
    setTimeRemaining(time: number)
    {
        this.timeRemaining(time);
    }
}







/**
 * get the game manager instance
 */
export function createGameManager() : GameManager
{
    return gameManager = new GameManager();
}


/**
 * get the game manager instance
 */
export function getGameManager() : GameManager
{
    return gameManager;
}


// WEBPACK FOOTER //
// ./src/ts/game/GameManager.ts